import React from 'react';

export const Tooltip = ({ content, children }) => (
  <div className="relative group inline-block">
    {children}
    <div
      className="absolute z-50 top-full left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block 
  p-2 rounded bg-gray-800 text-white text-xs shadow-lg w-[min(90vw,200px)] max-w-[90vw] text-left"
    >
      {content}
    </div>
  </div>
);
